export default {
  paged: {
    select: 'id,name,description,isActive',
    searchSelect: ['name', 'description'],
    orderBy: 'name',
  },
  item: {
    select: 'id,name,description,isActive',
  },
  itemDetail: {
    expand: {
      userCreator: { select: 'id,fullName' },
      userModifier: { select: 'id,fullName' },
    },
  },
};
